
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import BarcodeComponent from "../../../components/BarcodeComponent.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,
            
            loading: false,
            data: null,
            
            show_code: false,
            show_name: false,
            show_price: false,
            show_lot: false,
            paper_size: "100x100",
        }
    }
    show_code = false
    show_name = false
    show_price = false
    show_slot = false
    async componentDidMount() {
        await this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let result = await GET(tokens, "v1/TH/goods-receipt/barcode/" + getStorage("branch").branch_id);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data: result.data,
                show_code: result.data.show_code,
                show_name: result.data.show_name,
                show_price: result.data.show_price,
                show_lot: result.data.show_lot,
                paper_size: result.data.paper_size,
            })
            this.setState({ data: result.data });
        }
        this.setState({ loading: false });
    }

    Update = async () => {
        let result = null
        if(Object.keys(this.state.data).length === 0){
            console.log("create")
            result = await POST(tokens, "v1/TH/goods-receipt/barcode/create/"+ getStorage("branch").branch_id, {
                'show_code': this.state.show_code,
                'show_name': this.state.show_name,
                'show_price': this.state.show_price,
                'show_lot': this.state.show_lot,
                'paper_size': this.state.paper_size
            });
        } else {
            console.log("update")
            result = await PUT(tokens, "v1/TH/goods-receipt/barcode/update/"+ getStorage("branch").branch_id, {
                'show_code': this.state.show_code,
                'show_name': this.state.show_name,
                'show_price': this.state.show_price,
                'show_lot': this.state.show_lot,
                'paper_size': this.state.paper_size
            });
        }
        if (result && result.status) {
            success_url("/master/print-barcode");
        }
        this.setState({ loading: false });
    }

    clear_form = () => {
        this.setState({
            modal_create: false,
            modal_delete: false,
            modal_update: false,

            loading: false,

            company_id: "",
            name: "",
            address: "",
            business_location: "",
        })
    }

    render() {
        return (
            <div className="w-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="จัดการบริษัทที่จำหน่าย" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>ตั้งค่า Barcode</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex justify-content-center align-items-center p-3">
                                <BarcodeComponent value="1234567890" 
                                    show_code={this.state.show_code}
                                    show_name={this.state.show_name}
                                    show_price={this.state.show_price}
                                    show_lot={this.state.show_lot}
                                    paper_size={this.state.paper_size}
                                />
                            </div>
                            <div className="d-flex">
                                <div className="w-50 p-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                                        <span>แสดงรหัสสินค้า</span>
                                        <div className="form-check form-switch">
                                            <label className="switch">
                                            <input type="checkbox" checked={this.state.show_code} onChange={(e) => this.setState({ show_code: e.target.checked })} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                                        <span>แสดงชื่อสินค้า</span>
                                        <div className="form-check form-switch">
                                            <label className="switch">
                                                <input type="checkbox" checked={this.state.show_name}
                                                onChange={(e) => this.setState({ show_name: e.target.checked })} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                                        <span>แสดงราคา</span>
                                        <div className="form-check form-switch">
                                            <label className="switch">
                                                <input type="checkbox" checked={this.state.show_price}
                                                onChange={(e) => this.setState({ show_price: e.target.checked })} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                                        <span>แสดง LOT</span>
                                        <div className="form-check form-switch">
                                            <label className="switch">
                                                <input type="checkbox" checked={this.state.show_lot}
                                                onChange={(e) => this.setState({ show_lot: e.target.checked })} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-50 p-3">
                                    <div className="mb-2">
                                        <span>ขนาดกระดาษ</span>
                                        <select className="form-select mt-1" value={this.state.paper_size}
                                            onChange={(e) => this.setState({ paper_size: e.target.value })}>
                                            <option value="100x100">100mm x 100mm</option>
                                            <option value="76x26">76mm x 26mm</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end align-items-center py-3">
                            <button className="btn btn-outline-danger mx-1" onClick={() => { window.location.href = "/master" }}>
                                ยกเลิก
                            </button>
                            <button className="btn btn-danger mx-1" onClick={async () => await this.Update()}>
                                บันทึก
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
